/*
 * File: ui-block-autofill.ts
 * File Created: 2024-09-06 05:43:28
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 05:49:41
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "@root/core/utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";

// @uiBlockAutofill - reverse for @uiAutofill.
// allow value: true | false

@UITag.set()
export class uiBlockAutofill extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;

        let moreTags: IUITagMoreTagsUnit[] = [];
        moreTags.push({
            tag: "uiAutofill",
            rule: !rule,
        });
        return {
            specials: {
                moreTags,
            },
        };
    }
}
